import React from 'react'
import { DeleteContextMenuItem } from '../DeleteContextMenuItem'
import { EditTemplateFormModal } from '../Edit/EditTemplateFormModal'
import { CloneContextMenuItem } from '../CloneContextMenuItem'
import { HorizontalStack } from '@ztechapps/webui.util'

export const RowContextMenu = ({ template }) => {
  return (
    <HorizontalStack gap={1}>
      <EditTemplateFormModal template={template} />
      <CloneContextMenuItem template={template} />
      <DeleteContextMenuItem templateId={template?._id} />
    </HorizontalStack>
  )
}
